import { asyncRouterMap } from '@/router';
import { Message } from 'element-ui';
import store from '@/store';
import Config from '@/utils/config';
import Cache from '@/utils/cache';
import API from '@/http/api';
import http from '@/http/http';

/**
 * 判断是否登录，是否过期
 */
const isLogined = () => {
  const token = Cache.get(Config.TOKEN);
  const loginTime = Cache.get(Config.LOGIN_TIME);
  const n = new Date().getTime();
  if (loginTime && n - loginTime > 2 * 60 * 60 * 1000) {
    store.dispatch('app/loginOutNoFetch');
    Message.warning('身份验证已过期，请重新登录哦~');
    return null;
  }
  return token;
};

/**
 * 验证手机
 */
const checkPhone = (phone) => {
  return /^1[3456789]\d{9}$/.test(phone);
};

/**
 * 浏览器窗口大小变化时触发相应操作
 */
const windowOnresize = (func) => {
  document.getElementsByTagName('body')[0].style.height =
    window.innerHeight + 'px';
  document.getElementsByTagName('body')[0].style.transform =
    'scale(' + 1 + ',' + 1 + ')';
  window.onresize = () => {
    document.getElementsByTagName('body')[0].style.height =
      window.innerHeight + 'px';
    document.getElementsByTagName('body')[0].style.transform =
      'scale(' + 1 + ',' + 1 + ')';
    func && func();
  };
};

export { isLogined, checkPhone, windowOnresize };
